import type { FunctionComponent } from "react";
import { Link, useParams } from "react-router-dom";

export enum WalletTransactionsHeaderTabs {
	GST_APPROVAL = "gst-approval",
	INVOICE_APPROVAL = "invoice-approval",
}

export const WalletTransactionsHeaderAdminPartial: FunctionComponent = () => {
	const params = useParams<{ tab: WalletTransactionsHeaderTabs }>();

	return (
		<header className="flex px-10 py-4 h-24 justify-between items-center bg-background">
			<div>
				<h2 className="font-semibold text-2xl">Wallet Transactions</h2>
			</div>

			<div>
				<nav className="flex border border-[#FBFBFB]/10 rounded-10">
					{[
						{
							title: "Invoice Approval",
							tab: WalletTransactionsHeaderTabs.INVOICE_APPROVAL,
							path: `/admin/wallets/transactions/${WalletTransactionsHeaderTabs.INVOICE_APPROVAL}`,
						},
						{
							title: "GST Approval",
							tab: WalletTransactionsHeaderTabs.GST_APPROVAL,
							path: `/admin/wallets/transactions/${WalletTransactionsHeaderTabs.GST_APPROVAL}`,
						},
					].map((item) => {
						const isActive = params.tab === item.tab;
						return (
							<Link
								key={item.tab}
								to={item.path}
								className={`px-6 py-4 rounded-10 border ${isActive ? "border-[#FBFBFB]/80" : "border-transparent"}`}
							>
								<p>{item.title}</p>
							</Link>
						);
					})}
				</nav>
			</div>
		</header>
	);
};
